"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const app_service_1 = require("../../commons/app.service");
const router_1 = require("@angular/router");
const material_1 = require("@angular/material");
const core_2 = require("@ngx-translate/core");
const main_component_1 = require("../main.component");
const main_service_1 = require("../main.service");
const _4d_mapper_1 = require("4d-mapper");
const AppBaseComponent_1 = require("../../commons/AppBaseComponent");
const application_events_service_1 = require("../../xs/services/events/application-events.service");
const Cesium = window.Cesium;
class JobListComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, r, sn, d, ar, t, mainComponent, mainService, trans, applicationEvents) {
        super(service, r, sn, d, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.r = r;
        this.ar = ar;
        this.t = t;
        this.mainComponent = mainComponent;
        this.mainService = mainService;
        this.trans = trans;
    }
    onReady() {
        this.jobs = this.fourD.V.searchByObject(_4d_mapper_1.Job);
        this.jobs.queryObservable().subscribe();
    }
    addNew(jt) {
        var name = prompt('Name for job (do this nicer)');
        if (!name)
            return;
        var job = new _4d_mapper_1.Job(this.fourD.V).set({
            name: name,
            account: this.fourD.activeTeam,
            jobType: jt
        }).saveObservable().subscribe(res => this.selectedJob = res);
    }
}
exports.JobListComponent = JobListComponent;
